import React, { useEffect, useMemo, useRef, useState } from 'react';
import styles from './InfoTooltip.module.scss';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import ReactDOM from "react-dom";

const TOOLTIP_MAX_WIDTH = 450;
const TOP_MARGIN = 30;

const InfoTooltip = ({ text, icon = null, fixedPosition = false, containerRef = null }) => {
  const [isHover, setIsHover] = useState(false);
  const tooltipContainerRef = useRef(null);
  const [style, setStyle] = useState(null);

  const iconComponent = useMemo(() => {
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, {
        onMouseOver: () => setIsHover(true),
        onMouseLeave: () => setIsHover(false)
      })
    }
    return null;
  }, [icon])

  useEffect(() => {
    if (fixedPosition) {
      if (isHover) {
        const { left, top } = tooltipContainerRef.current.getBoundingClientRect();
        let offset = 0;
        if (left + TOOLTIP_MAX_WIDTH / 2 > innerWidth) {
          offset = TOOLTIP_MAX_WIDTH / 2;
        }
        setStyle({ zIndex: 999, position: 'fixed', opacity: 0, left: left - offset, top: top + TOP_MARGIN, transform: 'translateX(-50%)', transition: 'all 50ms ease-in-out, opacity: 150ms easy-in-out' });

        setTimeout(() => {
          setStyle(prevState => ({ ...prevState, opacity: 1 }));
        }, 100);
      } else {
        setStyle(prevState => ({ ...prevState, opacity: 0 }));
      }
    }
  }, [isHover])

  useEffect(() => {
    if (fixedPosition) {
      window.addEventListener('scroll', () => {
        setIsHover(false);
      });
    }
    return () => {
      window.removeEventListener('scroll', () => {
        setIsHover(false);
      });
    }
  }, [])

  return (
    <div className={styles.container} ref={tooltipContainerRef}>
      {iconComponent ? iconComponent : <div className={styles.iconWrapper} onMouseOver={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        <span className={styles.iconText}>i</span>
      </div>}
      {isHover && containerRef?.current?.parentNode && ReactDOM.createPortal(
        <Tooltip text={text} isHover={isHover} classNameTooltip={styles.infoContainer} position={'middle'} moveable={false} topPosition={25} tooltipStyle={style} />,
        containerRef?.current?.parentNode ?? document.body
      )}
      {!containerRef?.current?.parentNode && <Tooltip text={text} isHover={isHover} classNameTooltip={styles.infoContainer} position={'middle'} moveable={false} topPosition={25} tooltipStyle={style} />}
    </div>
  );
};

export default InfoTooltip;
